// ₹1,099 — Indian digit grouping, paise only when there are any (₹1,099.50)
const formatPrice = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '₹0';
  const hasPaise = Math.round(number * 100) % 100 !== 0;
  return `₹${number.toLocaleString('en-IN', {
    minimumFractionDigits: hasPaise ? 2 : 0,
    maximumFractionDigits: 2
  })}`;
};

export default formatPrice;
